import React from 'react';
import notSubscribedImage from '../../Assets/images/not-subscribed.png';
import '../../Assets/css/NotSubscribed.css';

const NotSubscribedMessageComponent = () => {
  return (
    <section className="notSubscribedFullWidth">
      <div className="notSubscribedContainer">
        <div className="row gy-4 align-items-center">
          <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center">
            <h1 data-aos="fade-up">
              You are not subscribed to this Service
            </h1>
            <p data-aos="fade-up" data-aos-delay="100">
              We offer the best solutions for Regulatory Compliance!
            </p>
            {/* <ul className="feature-list" data-aos="fade-up" data-aos-delay="150">
              <li>✅ Real-time Regulatory Alerts</li>
              <li>✅ Industry-specific Compliance Guidelines</li>
              <li>✅ Automated Report Generation</li>
            </ul> */}
            <div className="d-flex flex-column flex-md-row" data-aos="fade-up" data-aos-delay="200">
              <a className="contact_us" href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}?subject=Help`}>
                Contact Us <i className="bi bi-arrow-right"></i>
              </a>
              {/* < className="learn_more_btn" href="/services/regulatory-insights" style={{ marginLeft: '1rem' }}>
                Learn More
              </a>a */}
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-out">
            <img src={notSubscribedImage} className="img-fluid animated" alt="Not Subscribed" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotSubscribedMessageComponent;
